module.exports = __webpack_public_path__ + "7c350a76cb4d387d86acc5f2dc1ca0a7.png";